
export const formaterRestitutionNutritive = (restitution) => {
  if (restitution == null) {
    return ''
  }

  const apports = []
  if (restitution.apportAzote) {
    apports.push(`${restitution.apportAzote}uN`)
  }
  if (restitution.apportPhosphore) {
    apports.push(`${restitution.apportPhosphore}uP`)
  }
  if (restitution.apportPotassium) {
    apports.push(`${restitution.apportPotassium}uK`)
  }
  return apports.join(', ')
}

export default formaterRestitutionNutritive
